<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import AppShell from './components/AppShell.vue'
import OfflineIndicator from './components/OfflineIndicator.vue'
import { useConnectivityStore } from './stores/connectivity'
import { token } from './lib/api'

const connectivity = useConnectivityStore()
const route = useRoute()
let socket: WebSocket | null = null

function openSocket() {
  if (!token() || !navigator.onLine) return
  const protocol = location.protocol === 'https:' ? 'wss:' : 'ws:'
  socket = new WebSocket(`${protocol}//${location.host}/api/v1/ws?token=${encodeURIComponent(token()!)}`)
  socket.onopen = () => connectivity.socketConnected = true
  socket.onclose = () => {
    connectivity.socketConnected = false
    setTimeout(openSocket, 3000)
  }
  socket.onmessage = event => window.dispatchEvent(new CustomEvent('casamb-event', { detail: JSON.parse(event.data) }))
}
onMounted(() => { connectivity.start(); openSocket() })
onUnmounted(() => socket?.close())
</script>

<template>
  <OfflineIndicator />
  <AppShell v-if="!route.meta.public"><RouterView /></AppShell>
  <RouterView v-else />
</template>
